import { render, staticRenderFns } from "./plan_home.vue?vue&type=template&id=22dd0b78&"
import script from "./plan_home.vue?vue&type=script&lang=js&"
export * from "./plan_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports